/**
 * Protected Route Component
 * Redirects to login if user is not authenticated
 */

import { type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
}

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading } = useAuth();

  // Show logo splash while checking auth state
  if (loading) {
    return (
      <div
        className="flex items-center justify-center"
        style={{ height: '100dvh', background: 'hsl(var(--background))' }}
      >
        <img
          src="/numaa_logo_nobg.png"
          alt="numaa"
          className="animate-pulse"
          style={{ width: 96 }}
        />
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
